import { render, staticRenderFns } from "./Test2.vue?vue&type=template&id=1d1ec8f8&scoped=true&"
import script from "./Test2.vue?vue&type=script&lang=js&"
export * from "./Test2.vue?vue&type=script&lang=js&"
import style0 from "./Test2.vue?vue&type=style&index=0&id=1d1ec8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ec8f8",
  null
  
)

export default component.exports